import { useState } from "react";
import { Bell } from "lucide-react";
import { AppPopover } from "@/components/app/AppPopover";
import { Typography } from "@/components/app/Typography";
import { cn } from "@/lib/utils";

const notifications = [
  { id: 1, name: "Katie Sims",           time: "1h ago", msg: "Pellentesque suscipit fringilla libero eu ullamcorper. Cras risus eros, faucibus sit amet augue id, tempus pellentesque eros. In imperdiet", read: false, img: "/images/login-img.webp" },
  { id: 2, name: "Frances Swann",        time: "1h ago", msg: "Pellentesque suscipit fringilla libero eu ullamcorper. Cras risus eros, faucibus sit amet augue id, tempus pellentesque eros. In imperdiet", read: false, img: "/images/login-img.webp" },
  { id: 3, name: "James Hall",           time: "1h ago", msg: "Pellentesque suscipit fringilla libero eu ullamcorper. Cras risus eros, faucibus sit amet augue id, tempus pellentesque eros. In imperdiet", read: false, img: "/images/login-img.webp" },
  { id: 4, name: "Ricky Smith",          time: "1h ago", msg: "Pellentesque suscipit fringilla libero eu ullamcorper. Cras risus eros, faucibus sit amet augue id, tempus pellentesque eros. In imperdiet", read: false, img: "/images/login-img.webp" },
  { id: 5, name: "Paula Mora",           time: "1h ago", msg: "Pellentesque suscipit fringilla libero eu ullamcorper. Cras risus eros, faucibus sit amet augue id, tempus pellentesque eros. In imperdiet", read: true,  img: "/images/login-img.webp" },
  { id: 6, name: "Kimberly Mastrangelo", time: "1h ago", msg: "Pellentesque suscipit fringilla libero eu ullamcorper. Cras risus eros, faucibus sit amet augue id, tempus pellentesque eros. In imperdiet", read: true,  img: "/images/login-img.webp" },
];

export function NotificationPopover() {
  const [tab, setTab] = useState<"all" | "unread">("all");
  const unreadCount = notifications.filter((n) => !n.read).length;
  const filtered = tab === "unread" ? notifications.filter((n) => !n.read) : notifications;

  const trigger = (
    <button
      aria-label="Notifications"
      className="relative flex items-center justify-center h-10 w-10 rounded-full hover:bg-accent transition-colors text-[#887771]"
    >
      <Bell size={24} />
      {unreadCount > 0 && (
        <span className="absolute top-1.5 right-1.5 h-2 w-2 rounded-full bg-destructive" />
      )}
    </button>
  );

  return (
    <AppPopover trigger={trigger} overlay>
      {/* Header */}
      <div className="flex items-center justify-between px-5 pt-5 pb-4 border-b border-border-light">
        <Typography variant="h4" color="primary" >
          Notifications
        </Typography>
        <div className="flex items-center rounded-full p-1 gap-1 border border-border-light">
          {(["all", "unread"] as const).map((t) => (
            <button
              key={t}
              onClick={() => setTab(t)}
              className={cn(
                "px-5 py-1.5 rounded-full text-base font-medium transition-colors capitalize md:h-[52px] md:min-w-[107px] flex justify-center items-center",
                tab === t
                  ? "bg-primary text-primary-foreground"
                  : "text-muted-foreground hover:text-foreground"
              )}
            >
              {t === "all" ? "All" : "Unread"}
            </button>
          ))}
        </div>
      </div>

      {/* List */}
      <div className="max-h-[420px] overflow-y-auto divide-y divide-border-light scrollbar-thin">
        {filtered.length === 0 ? (
          <div className="py-10 text-center">
            <Typography variant="body2" color="muted">No notifications</Typography>
          </div>
        ) : filtered.map((n) => (
          <div key={n.id} className=" p-3 md:p-5 hover:bg-muted/40 transition-colors cursor-pointer">
            <div className="relative flex items-start gap-3">
            <div className="h-11 md:w-[59px] w-11 md:h-[59px] rounded-full overflow-hidden shrink-0 bg-muted">
              <img src={n.img} alt={n.name} className="object-cover h-full w-full" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-1.5 flex-wrap">
                <Typography className="font-bold">{n.name}</Typography>
                <Typography variant="caption" color="muted">{n.time}</Typography>
              </div>
              <Typography variant="caption" color="muted" className="line-clamp-2 mt-0.5">
                {n.msg}
              </Typography>
            </div>
            {!n.read && (
              <span className="absolute top-2 right-0 h-2.5 w-2.5 rounded-full bg-success" />
            )}
          </div>
          </div>
        ))}
      </div>
    </AppPopover>
  );
}
